'use client'

import { Toaster } from 'react-hot-toast'

/**
 * Ces styles référençaient les anciens tokens (--color-input-invalid,
 * --color-text…) supprimés lors de la refonte : les toasts s'affichaient
 * sur fond transparent, en encre foncée, donc invisibles au-dessus de la
 * section contact sombre. Ils utilisent désormais la palette courante.
 */
export function ToastProvider() {
  return (
    <Toaster
      position="bottom-center"
      toastOptions={{
        duration: 5000,
        style: {
          fontFamily: 'var(--font-mono)',
          fontSize: '0.8125rem',
          lineHeight: 1.5,
          maxWidth: '32rem',
          borderRadius: '3px',
          padding: '0.875rem 1.125rem',
          background: 'var(--color-ink)',
          color: 'var(--color-chalk)',
          border: '1px solid var(--color-anthracite)',
        },
        success: {
          style: {
            background: 'var(--color-ink)',
            color: 'var(--color-chalk)',
            borderColor: 'var(--color-patina)',
          },
          iconTheme: {
            primary: 'var(--color-patina)',
            secondary: 'var(--color-chalk)',
          },
        },
        error: {
          // Le seul autre emplacement où le signal fait office d'alerte.
          duration: 7000,
          style: {
            background: 'var(--color-ink)',
            color: 'var(--color-chalk)',
            borderColor: 'var(--color-signal)',
          },
          iconTheme: {
            primary: 'var(--color-signal)',
            secondary: 'var(--color-chalk)',
          },
        },
      }}
    />
  )
}
